import { faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useClipboard } from "@mantine/hooks";
import { Tooltip } from "components/UI/Tooltip";
import { usePublicTracks } from "hooks/usePublicTracks";
import { useUserTracks } from "hooks/useUserTracks";
import { useTranslation } from "react-i18next";
import { useOptions } from "stores/optionsStore/OptionsContext";
import { showSuccessNotification } from "utils/notifications/customNotifications";
import { CollapsibleTopMenuActionIcon } from "../../../../components/UI/TopMenu/CollapsibleActionIcon";

export const CopyToClipboardIcon = ({ isOpen }: { isOpen: boolean }) => {
  const { selectedTrack } = useUserTracks();
  const { selectedTrack: selectedPublicTrack } = usePublicTracks();
  const { state } = useOptions();
  const clipboard = useClipboard();
  const { t } = useTranslation();

  const copyTrackToClipboard = () => {
    const link = `${window.location.origin}/?basemap=${state.mapType}&trkid=${
      selectedTrack?.uuid ?? selectedPublicTrack?.uuid
    }`;
    clipboard.copy(link);

    showSuccessNotification({
      message: t(
        "editmode.copy_link_to_clipboard.success_notification_message"
      ),
    });
  };

  // Only a saved track has a link (an own or a public one)
  const hasLink = !!selectedTrack || !!selectedPublicTrack;

  return (
    <Tooltip
      label={
        hasLink
          ? t("editmode.copy_link_to_clipboard.tooltip")
          : t("editmode.copy_link_to_clipboard.disabled_tooltip")
      }
    >
      <div>
        <CollapsibleTopMenuActionIcon
          isOpen={isOpen}
          disabled={!hasLink}
          onClick={copyTrackToClipboard}
        >
          <FontAwesomeIcon icon={faLink} />
        </CollapsibleTopMenuActionIcon>
      </div>
    </Tooltip>
  );
};
